import React from "react"
import {Button} from 'reactstrap';

const TButton = ({ onEvent }) => {
  return (
    <th>
      <Button
        className="delete-btn"
        onClick={onEvent}
      >
        Delete
      </Button>
    </th>
  )
}

export default TButton



// WEBPACK FOOTER //
// ./src/new-components/admin/table/TButton.js